export default __webpack_public_path__ + "static/media/background-pattern.1bfe4f75.png";